import React from 'react';
import { Box, Divider, Grid } from '@material-ui/core';
import { sizes } from 'src/styles/Media.styled';
import { Title } from '../Procedure.styled';
import RadioButton from 'src/common/refactoredComponents/RadioButton/RadioButton';
import { isIpad, logErrorToConsole } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { BASE_TEXT_PX, FONT_FAMILY_REGULAR } from '../../../styles/fonts/MCFontConstants';
const DeformityCorrectionCard = ({
    deformityTechnologiesData,
    radioButtonChangeHandler,
}) => {
    const winWidth = window.innerWidth;
    const isMobileView = winWidth < sizes.smalDevice;
    const { t } = useTranslation();
    return (
        <Box
            my={1}
            bgcolor={'#ffffff'}
            boxShadow={'0px 0px 6px #00000029'}
            borderRadius={5}
            padding={!isMobileView && '16px 0px 16px 0px'}
            width={'99.66%'}
            position={'relative'}
            marginLeft={'1px'}
            marginRight={'1px'}
            border={
                deformityTechnologiesData.filter((item) => item.isSelected)
                    .length > 0
                    ? '1px solid #12C8F7'
                    : ''
            }
        >
            <Grid container>
                <Grid
                    item
                    xs={12}
                    md={12}
                    style={{ padding: isMobileView && '16px 22px 0' }}
                >
                    <Title
                        paddingBtm={isMobileView ? '20px' : '10px'}
                        mbpaddingBtm={'20px'}
                        paddingLeft={!isMobileView && '20px'}
                        fontSize={BASE_TEXT_PX}
                    >
                        <span>
                            {t(
                                'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.deformityCorrection'
                            )}
                        </span>
                        <span className="asterisk">*</span>
                    </Title>
                </Grid>
                {isMobileView && (
                    <Grid item xs={12} style={{ paddingBottom: '12px' }}>
                        <Divider />
                    </Grid>
                )}
                {deformityTechnologiesData &&
                    deformityTechnologiesData.map((obj, idx) => (
                        <Grid
                            key={`${idx.toString() + 1}`}
                            item
                            xs={isIpad() ? 4 : isMobileView ? 12 : 6}
                            md={isMobileView ? 12 : isIpad() ? 4 : 4}
                            sm={4}
                            style={{
                                display: 'flex',
                                padding: isMobileView
                                    ? '0 22px 16px'
                                    : isIpad()
                                    ? '0px 0px 20px 20px'
                                    : '0 20px 20px 20px',
                                marginRight: isIpad() ? '0px' : 'unset',
                                justifyContent: isIpad()
                                    ? 'flex-start'
                                    : isMobileView
                                    ? 'flex-start'
                                    : 'space-between',
                            }}
                        >
                            <RadioButton
                                key={idx}
                                id={`deformityId-${obj.description}`}
                                isChecked={obj.description === obj.isSelected}
                                label={obj.description}
                                handleChange={() => {
                                    try {
                                        radioButtonChangeHandler(
                                            'deformityData',
                                            idx,
                                            obj.description
                                        );
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                                fontFamilyStyle={FONT_FAMILY_REGULAR}
                                fontSize={BASE_TEXT_PX}
                                padding={
                                    window.innerWidth <= sizes.mobileDevice &&
                                    '0 70px 0 0'
                                }
                                width={'14px'}
                            />
                        </Grid>
                    ))}
            </Grid>
        </Box>
    );
};

export default DeformityCorrectionCard;
